interface Feature {
  icon: string;
  title: string;
  desc: string;
}

const features: Feature[] = [
  {
    icon: 'ri-shield-check-line',
    title: '高清流畅',
    desc: '最高支持1080P全高清画质，智能码率自适应技术，根据网络环境自动调节清晰度，确保零缓冲流畅播放。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '每日更新',
    desc: '专业编辑团队每日同步更新最新影视资源，院线大片、热播剧集、综艺节目第一时间上线，永不错过精彩内容。',
  },
  {
    icon: 'ri-user-star-line',
    title: '完全免费',
    desc: '无需注册、无需付费、无隐藏收费，所有影视资源均可免费在线观看。我们坚持用户至上的运营理念。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1000px] mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">平台优势</h2>
            <p className="text-sm text-foreground-600 mt-1">为什么选择人人影院</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            {features.map((f, i) => (
              <div
                key={i}
                className="bg-background-100 rounded-xl p-6 text-center border border-background-200/60 hover:border-primary-500/20 transition-colors"
              >
                <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-2xl bg-primary-500/10 mb-4">
                  <i className={`${f.icon} text-primary-500 text-2xl`}></i>
                </div>
                <h3 className="font-heading text-lg text-foreground-950 mb-2">{f.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}